import { render, staticRenderFns } from "./changeFeeShow.vue?vue&type=template&id=545667d8&scoped=true"
import script from "./changeFeeShow.vue?vue&type=script&lang=js"
export * from "./changeFeeShow.vue?vue&type=script&lang=js"
import style0 from "./changeFeeShow.vue?vue&type=style&index=0&id=545667d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545667d8",
  null
  
)

export default component.exports